export default __webpack_public_path__ + "static/media/NPM Video Preview.ec8bbcec.png";